import React from 'react'
import { TableHeaderConfigWithType } from '../../components/_EOS/Table'
import { fechaFormateada } from '../../utils/dateHelper'
import { ExternalAudit } from './entities/ExternalAudit'
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material'
import { eStatus, eTypeAction } from '../../enums/eExternalAudit'
import { sinDato } from './config'

export const generateTableHeadersExternalAudit = () => {
  const tableHeadersExternalAudit: TableHeaderConfigWithType<ExternalAudit>[] =
    [
      {
        field: 'referenceId',
        fieldReplacement: 'referenceId',
        title: 'ID Referencia',
        sortable: false,
        formater: (valor: unknown) => sinDato(valor)
      },
      {
        field: 'typeActionId',
        title: 'Tipo',
        sortable: false,
        formater: (typeActionId: unknown) => setType(typeActionId as number)
      },
      {
        field: 'externalName',
        title: 'Externo',
        sortable: false
      },
      {
        field: 'brand',
        title: 'Marca',
        sortable: false
      },
      {
        field: 'requestUrl',
        title: 'URL',
        sortable: false
      },
      {
        field: 'transactionDate',
        title: 'Fecha Llamada',
        sortable: false,
        formater: (transactionDate: unknown) =>
          fechaFormateada(transactionDate, 'dd/MM/yyyy hh:mm a')
      },
      {
        field: 'statusId',
        title: 'Estado',
        sortable: false,
        formater: (statusId: unknown) =>
          setIconSuccessfulState(statusId as number)
      }
    ]

  return tableHeadersExternalAudit
}

const setIconSuccessfulState = (statusId: number) => {
  const isSuccess =
    statusId === eStatus.Ejecutado || statusId === eStatus.Satisfactorio
  const Icon = isSuccess ? CheckIcon : CloseIcon
  let backgroundColor = ''
  let colorText = ''

  switch (statusId) {
    case eStatus.Ejecutado:
      backgroundColor = '#1976d2'
      colorText = 'white'
      break
    case eStatus.Satisfactorio:
      backgroundColor = '#4caf50'
      colorText = 'white'
      break
    default:
      backgroundColor = '#f48fb1'
      colorText = 'black'
      break
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '20px',
        backgroundColor,
        color: colorText,
        fontSize: '10px'
      }}
    >
      <Icon style={{ marginRight: '2px' }} />
      {eStatus[statusId]}
    </div>
  )
}

const setType = (idType: number) => {
  return eTypeAction[idType] || ''
}
